import { TechCareServicesClient } from '@service-initiation/shared-clients-tech-care-services';

import { httpClient } from './httpClient';

export const techCareServicesClient = new TechCareServicesClient({
  baseUrl: process.env['NX_PUBLIC_UBIF_API_GATEWAY_URL'],
  httpClient,
});
